module.exports = __webpack_public_path__ + "img/soup.d5de4d93.jpg";